
import { ImplementationStateEnum, PermissionTypeEnum } from '@/libs/Api';
import { Component, Prop, VModel, Vue } from 'vue-property-decorator';
import { authStore } from '@/libs/auth/+store/store';
import { AuthGetter } from '@/libs/auth/models/auth-state';

@Component({})
export default class ImplementationStateToggle extends Vue {
    protected ImplementationStateEnum: typeof ImplementationStateEnum = ImplementationStateEnum;
    protected PermissionTypeEnum: typeof PermissionTypeEnum = PermissionTypeEnum;

    get items() {
        if (this.canBeVerified) {
            return [
                { id: ImplementationStateEnum.New, name: this.$i18n.t('issueDialog.new') },
                { id: ImplementationStateEnum.InProgress, name: this.$i18n.t('issueDialog.inProgress') },
                {
                    id: ImplementationStateEnum.WaitingForVerification,
                    name: this.$i18n.t('issueDialog.performedSendToVerification'),
                },
                { id: ImplementationStateEnum.Verified, name: this.$i18n.t('issueDialog.verifiedWhenPerformed') },
            ];
        } else {
            return [
                { id: ImplementationStateEnum.New, name: this.$i18n.t('issueDialog.new') },
                { id: ImplementationStateEnum.InProgress, name: this.$i18n.t('issueDialog.inProgress') },
                { id: ImplementationStateEnum.WaitingForVerification, name: this.$i18n.t('issueDialog.performed') },
            ];
        }
    }

    @VModel() innerValue!: string;
    @Prop({ default: '' }) label!: string;
    @Prop({ default: false }) mandatory!: boolean;
    @Prop({ default: false }) canBeVerified!: boolean;

    public hasPermissions(permissionTypes: PermissionTypeEnum[]): boolean {
        if (!permissionTypes) return true;
        const permissions = authStore.useGetter(AuthGetter.GetPermissions) as PermissionTypeEnum[];
        return permissions.any((x) => permissionTypes.any((p) => p == x));
    }
}
